import { TimeSeriesAreaGraphPoint } from '../TimeseriesAreaGraph';

export const formatDateAndMonthTick = (value: string) => {
  const date = new Date(value);
  return `${date.getDate()}/${date.getMonth() + 1}`;
};

export const formatMonthlyTick = (value: string) => {
  const date = new Date(value);
  const showYear = date.getMonth() === 0;
  return date.toLocaleString('default', { month: 'short', year: showYear ? 'numeric' : undefined });
};
export const formatYearlyTick = (value: string) => `${value.substring(0, 4)}`;

export const getDailyXAxisTicks = (points: TimeSeriesAreaGraphPoint[]): string[] =>
  points.map((point) => point.date);

export const getMonthlyXAxisTicks = (points: TimeSeriesAreaGraphPoint[]): string[] =>
  points.reduce((acc, point) => {
    const monthYear = `${new Date(point.date).getMonth() + 1}/${new Date(point.date).getFullYear()}`;
    const isMonthYearAlreadyAdded =
      acc.findIndex((date) => {
        const dateMonthYear = `${new Date(date).getMonth() + 1}/${new Date(date).getFullYear()}`;
        return dateMonthYear === monthYear;
      }) >= 0;
    if (isMonthYearAlreadyAdded) {
      return acc;
    }
    return [...acc, point.date];
  }, [] as string[]);

export const getYearlyXAxisTicks = (points: TimeSeriesAreaGraphPoint[]): string[] =>
  points.reduce((acc, point) => {
    const isYearAlreadyAdded =
      acc.findIndex((date) => date.substring(0, 4) === point.date.substring(0, 4)) >= 0;
    if (isYearAlreadyAdded) {
      return acc;
    }
    return [...acc, point.date];
  }, [] as string[]);
